import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import './colores.css'

class MyDialog extends React.Component {

    render() {
        return (
        
            <Dialog
                open={true}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {this.props.mostrarTitulo &&
                <DialogTitle id="alert-dialog-title">
                    {this.props.titulo}
                </DialogTitle>}
                
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.props.cuerpo}
                    </DialogContentText>
                </DialogContent>
                
                <div id='ecommerce'>
                <DialogActions>
                    {this.props.mostrarBotonCancelar &&        
                    <Button   onClick={() => {this.props.handleOnCancelar()}} className="btnSecundario">
                        {this.props.botonCancelar}
                    </Button>
                     }
                    

                    {this.props.mostrarBotonConfirmar &&
                    
                        <Button  onClick={() => {this.props.handleOnConfirmar(true)}} className='btnPrincipal' autoFocus >
                            {this.props.botonConfirmar}
                        </Button>
                        
                    }
                     
                </DialogActions>
                </div>
            </Dialog>
            
        )
    }
}

MyDialog.propTypes = {
    handleOnConfirmar: PropTypes.func.isRequired,
    handleOnCancelar: PropTypes.func.isRequired,
    titulo: PropTypes.string,
    mostrarTitulo: PropTypes.bool,
    cuerpo: PropTypes.node,
    botonConfirmar: PropTypes.string,
    botonCancelar: PropTypes.string,
    mostrarBotonConfirmar: PropTypes.bool,
    mostrarBotonCancelar: PropTypes.bool
}

MyDialog.defaultProps = {
    handleOnConfirmar: f => f,
    handleOnCancelar: f => f,
    mostrarTitulo: true,
    cuerpo: <div></div>,
    botonConfirmar: 'ACEPTAR',
    botonCancelar: 'CANCELAR',
    mostrarBotonConfirmar: true,
    mostrarBotonCancelar: true,
}

export default MyDialog